import { useEffect, useMemo, useState } from "react";
import { PrimaryPopover, useAicoConnection } from "../../../../../Components";
import { ButtonTypes, ListData_ValueTypes, PopoverPosition } from "../../../../../Definitions";
import { colors, glyphs } from "../../../../../Styles";
import { LC_FEED_DAY, LCFeedDayArgs, LCFeedDayResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/lcFeedDay";
import { GenericDeviceTable } from "../../../../../Components/ToolsComponents/genericDeviceDataTable";
import NewButton from "../../../../../Components/BaseComponents/newButton";
import ResetTableModal from "../../../../../Components/ToolsComponents/Modals/resetTableModal";
import { LC_TABLE_IDS } from "../../../../../Definitions/lcTableIds";
import { useLazyQuery } from "@apollo/client";

const columnsData = [
	{ headerValue: "ID", accessor: "id", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "milestoneId", accessor: "milestoneId", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "feedcurveId", accessor: "feedcurveId", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "day", accessor: "day", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "nDay", accessor: "nDay", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "compCnt", accessor: "compCnt", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "feedcurve_day_components", accessor: "feedcurve_day_components", type: ListData_ValueTypes.Div, sort: false },
]

export default function FeedDayDataTable() {
	const [isResetTableModalOpen, setIsResetTableModalOpen] = useState<boolean>(false);

	const { state: connectionState } = useAicoConnection();

	const [fetchData, {data, loading, error }] = useLazyQuery<LCFeedDayResponse, LCFeedDayArgs>(LC_FEED_DAY, { fetchPolicy: "network-only" });

	useEffect(() => {
		if (connectionState.deviceConnection) {
			fetchData({variables: connectionState.deviceConnection});
		}
	}, [connectionState.deviceConnection]);

	const tableData = useMemo(() => {
		return data?.controller.lcFeedDay?.map((e, i) => {
			let componentCell: React.ReactNode | undefined = undefined;

			if (e.feedcurve_day_components.length) {
				componentCell = (
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<PrimaryPopover
							content={
								<div style={{ width: "fit-content", height: "fit-content", margin: "-5px 0px", cursor: "pointer" }}>
									<glyphs.Note fillColor={colors.greyDarkPrimary} />
								</div>
							}
							overrides={{
								popoverPosition: PopoverPosition.bottom
							}}
							popoverHeader={"Components"}
							popoverContent={
								<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", color: colors.whitePrimary }}>
									Component Id | Amount
									{e.feedcurve_day_components.map((dayComponent, index) =>
										<div key={index}>{dayComponent.componentId} : {dayComponent.amount}</div>
									)}
								</div>
							}
						/>
					</div>
				);
			}

			return {
				...e,
				id: i,
				feedcurve_day_components: componentCell,
			}
		}) ?? [];
	}, [data]);

	return (
		<>
			<GenericDeviceTable
				title="Feed Days"
				columnsData={columnsData}
				data={tableData}
				loading={loading}
				error={error}
				onFetch={() => connectionState.deviceConnection && fetchData({ variables: connectionState.deviceConnection })}
				tabButtons={[
					<NewButton
						key="Reset table"
						content="Reset Table"
						startEnhancer={glyphs.ArrowReset({})}
						onClick={() => {
							setIsResetTableModalOpen(true);
						}}
						buttonType={ButtonTypes.tableButton}
						disabled={!connectionState.deviceConnection}
					/>
				]}
			/>
			{connectionState.deviceConnection && 
				<ResetTableModal
					isModalOpen={isResetTableModalOpen}
					closeModal={()=>{ setIsResetTableModalOpen(false) }}
					onSuccess={() => fetchData({ variables: connectionState.deviceConnection })}
					tableId={LC_TABLE_IDS.feeddays}
				/>
			}
		</>
	)
}